import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  token: string | null;
  email: string | null;
  displayName: string | null;
  isAdmin: boolean;
  login: (
    token: string,
    email: string,
    isAdmin: boolean,
    displayName?: string | null
  ) => void;
  setDisplayName: (name: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      email: null,
      displayName: null,
      isAdmin: false,
      login: (token, email, isAdmin, displayName = null) =>
        set({ token, email, isAdmin, displayName }),
      setDisplayName: (displayName) => set({ displayName }),
      logout: () =>
        set({ token: null, email: null, isAdmin: false, displayName: null }),
    }),
    { name: "fintbot-auth" }
  )
);
